import type {SafeHTMLString} from '@github-ui/safe-html'
import {VerifiedHTMLDiv} from '@github-ui/safe-html/VerifiedHTML'
import {clsx} from 'clsx'

import {scrollLineIntoView} from '../../hooks/use-scroll-line-into-view'
import {CodeLine} from '../blob/BlobContent/Code/CodeLine'
import type {CodeLineData} from '../blob/BlobContent/Code/hooks/use-code-lines'
import {LineNumber} from '../blob/BlobContent/Code/LineNumber'
import styles from './StickyLinesHeader.module.css'

export function StickyLinesHeader({
  currentStickyLines,
  colorizedLines,
}: {
  currentStickyLines: Map<number, CodeLineData>
  colorizedLines?: SafeHTMLString[] | null
}) {
  const stickyLines = Array.from(currentStickyLines.values())

  return (
    <div className={styles.Box}>
      <div className={clsx('react-line-numbers', styles.Box_1)}>
        {stickyLines.map(stickyLine => {
          return <LineNumber key={`sticky-header-line-number-${stickyLine.lineNumber}`} codeLineData={stickyLine} />
        })}
      </div>
      <div className="react-code-lines">
        {stickyLines.map(stickyLine => {
          if (colorizedLines && colorizedLines[stickyLine.lineNumber - 1]) {
            return (
              <VerifiedHTMLDiv
                className="react-code-text react-code-line-contents-no-virtualization react-file-line html-div"
                key={`sticky-header-line-${stickyLine.lineNumber}`}
                style={{paddingLeft: '18px'}}
                html={colorizedLines[stickyLine.lineNumber - 1]}
                onClick={() => scrollLineIntoView({line: stickyLine.lineNumber})}
              />
            )
          }
          return (
            <CodeLine
              key={`sticky-header-line-${stickyLine.lineNumber}`}
              codeLineData={stickyLine}
              stylingDirectivesLine={stickyLine.stylingDirectivesLine}
              codeLineToSectionMap={undefined}
              copilotAccessAllowed={false} // we're not going to show copilot buttons in the sticky lines
              onClick={() => scrollLineIntoView({line: stickyLine.lineNumber})}
              shouldUseInert={false}
            />
          )
        })}
      </div>
    </div>
  )
}

try{ StickyLinesHeader.displayName ||= 'StickyLinesHeader' } catch {}